import React, {Component, ErrorInfo, ReactNode} from "react";
import {AdminErrorMessage} from "./message/AdminErrorMessage";

interface ErrorBoundaryProps {
    children: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
    errorInfo?: ErrorInfo;
    error?: Error;
}

class AdminErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        // Update state so the next render will show the fallback UI.
        return {hasError: true, error};
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        // Log error, it can be found and investigated via full story
        console.error('Error caught by adminErrorBoundary:', error, errorInfo);
        this.setState({...this.state, errorInfo, error });
    }

    componentDidUpdate(prevProps: ErrorBoundaryProps) {
        // Reset hasError if the children prop has changed
        if (this.props.children !== prevProps.children) {
            this.setState({ hasError: false });
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <AdminErrorMessage errorInfo={this.state.errorInfo} error={this.state.error}/>
            );
        }
        return this.props.children;
    }
}

export default AdminErrorBoundary;

